var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C6.721 0 0 6.721 0 15C0 23.279 6.721 30 15 30C23.279 30 30 23.279 30 15C30 6.721 23.279 0 15 0ZM15 2C22.175 2 28 7.825 28 15C28 22.175 22.175 28 15 28C7.825 28 2 22.175 2 15C2 7.825 7.825 2 15 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13.586L10.707 9.29299C10.317 8.90299 9.68299 8.90299 9.29299 9.29299C8.90299 9.68299 8.90299 10.317 9.29299 10.707L13.586 15L9.29299 19.293C8.90299 19.683 8.90299 20.317 9.29299 20.707C9.68299 21.097 10.317 21.097 10.707 20.707L15 16.414L19.293 20.707C19.683 21.097 20.317 21.097 20.707 20.707C21.097 20.317 21.097 19.683 20.707 19.293L16.414 15L20.707 10.707C21.097 10.317 21.097 9.68299 20.707 9.29299C20.317 8.90299 19.683 8.90299 19.293 9.29299L15 13.586Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4367b4590ae9494ec6cb11411fd32a5a.svg";
export { ForwardRef as ReactComponent };